export default __webpack_public_path__ + "static/media/4.17202c85.png";